import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import styles from './Contact.css';
import FullWidthRegion from '../components/FullWidthRegion';
import Separator from '../components/Separator';

class Contact extends Component {
  componentDidMount() {
    document.title = 'Jennifer Zwick‘s Contact Page';
  }

  render() {
    return (
      <div styleName="wrapper">
        <FullWidthRegion>
          <h2 styleName="page-title">Contact</h2>

          <Separator />

          <p styleName="email">Contact me at <a href="mailto:jen@jenniferzwick.com">jen@jenniferzwick.com</a></p>

          <div styleName="form-wrapper">
            <form action="//jenniferzwick.us11.list-manage.com/subscribe/post?u=ec022424b697d7c7a052af24c&amp;id=6f6ef532d6" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
              <div id="mc_embed_signup_scroll">
                <label styleName="label" htmlFor="mce-EMAIL">Can you sign up to receive art news and updates? Yes, you sure can!</label>
                <input styleName="input" type="email" name="EMAIL" className="email" id="mce-EMAIL" placeholder="Email Address" required />
                <div styleName="hide"><input type="text" name="b_ec022424b697d7c7a052af24c_6f6ef532d6" tabIndex="-1" /></div>
                <div><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" styleName="button" /></div>
              </div>
            </form>

            <Separator />

            <p><a
              href="http://jenniferzwick.us11.list-manage.com/subscribe?u=ec022424b697d7c7a052af24c&id=6f6ef532d6"
              target="_blank"
              rel="noopener noreferrer"
            >Or, head over to the wordier version of my email signup form.</a></p>
          </div>
        </FullWidthRegion>
      </div>
    );
  }
}

export default CSSModules(Contact, styles, { errorWhenNotFound: false });



// WEBPACK FOOTER //
// ./application/js/pages/Contact.js